'use strict';

const sortEvents = (events, sortOption = null) => {
  if (sortOption == 'date') {
    return events.sort(sortByDate);
  } else if (sortOption == 'metalocation') {
    return events.sort(sortByName);
  } else {
    return events;
  }
};

function sortByName(a, b) {
  return a.content.location < b.content.location
    ? -1
    : a.content.location > b.content.location
      ? 1
      : 0;
}

function sortByDate(a, b) {
  let tempA = a.content.startDate.split('/');
  const dateA = new Date(tempA[2], tempA[1] - 1, tempA[0]);
  let tempB = b.content.startDate.split('/');
  const dateB = new Date(tempB[2], tempB[1] - 1, tempB[0]);

  return dateA < dateB ? -1 : dateA > dateB ? 1 : 0;
}

export default sortEvents;
